// extracted by mini-css-extract-plugin
module.exports = {"loader":"NewInvoiceCard_loader__33_JR","load3":"NewInvoiceCard_load3__3CDPr"};